import React from 'react';
import { isRouteErrorResponse, useRouteError } from 'react-router-dom';
import Banner from '../../components/home/BannerHome';
import PromoList from '../../components/home/PromoListHome';
import CategoryList from '../../components/home/CategoryListHome';
import HotDealsList from '../../components/home/HotDealsListHome';
import BrandSelection from '../../components/home/BrandSelection';

import Delivery from '../../components/home/DeliveryHome';
import FetureList from '../../components/home/FeatureListHome';
import NewArrivalProducts from './NewArrivalProducts';
import RecommendedProductHome from './RecommendedProductHome';
const HomePage = () => {
    return (
        <>
            {/* BannerOne */}
            <Banner />

            {/* CategoryList */}
            <CategoryList />

            {/* FetureList */}
            <FetureList />

            {/* PromoList */}
            {/* <PromoList /> */}

            {/* BrandSelection */}
            <BrandSelection />

            {/* HotDealsList */}
            <NewArrivalProducts />

            {/*RecommendedProductsHome*/}
            <RecommendedProductHome />

            {/* HotDealsList */}
            {/* <HotDealsList /> */}

            {/* DeliveryOne */}
            {/* <Delivery /> */}
        </>
    );
};

export default HomePage;
